class PageReviews extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const self = this;
    self._manageState();
    document.addEventListener('shopify:block:select', function (e) {
      let state = {}
      const stateKey = document.querySelector(`#shopify-block-${e.detail.blockId} review-block`).dataset.type;
      const nextState = document.querySelector(`#shopify-block-${e.detail.blockId} [data-next-state]`).dataset.type;
      const stateData = {
        'next_state': stateKey,
        'value': ''
      }
      state[stateKey] = stateData;
      debugger
      self.updateState(stateKey, state);
    });
  }
  _manageState() {
    if (location.search.includes("contact_posted=true")) {
      this.dataset.currentState = "form-block";
    }
    this.classList.add('load');
  }
  updateState(key, state) {
    this.dataset.currentState = state[key].next_state;
    this._saveState(state);
  }
  _saveState(state = {}) {
    window.sessionStorage.setItem('page-reviews', JSON.stringify(state));
  }
}

class ReviewBlock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const self = this;
    self.starIcons = self.querySelectorAll('.star-icon');
    if (self.starIcons.length) {
      self.starIcons.forEach((icon) => {
        icon.addEventListener('mouseenter', self._animateStars.bind(self));
        icon.addEventListener('mouseleave', self._resetAnimation.bind(self));
      });
    }
    const stateUpdateElems = self.querySelectorAll('[data-next-state]');
    stateUpdateElems.forEach(elem => {
      elem.addEventListener("click", self._updateState.bind(self));
    }); 
  }
  _animateStars(e) {
    const starArray = new Array(...this.starIcons);
    const currentIndex = starArray.indexOf(e.currentTarget);
    for (let index = currentIndex; index > -1; index--) {
      starArray[index].classList.add('fill');
    }
    for (let index = currentIndex+1; index < starArray.length; index++) {
      starArray[index].classList.remove("fill");
    }
  }
  _resetAnimation(e) {
    const starArray = new Array(...this.starIcons);
    starArray.forEach((icon) => {
      icon.classList.remove('fill');
    });
  }
  _updateState(e) {
    const target = e.currentTarget;
    const state = {},
      stateKey = this.dataset.type;
    let stateData;
    stateData = {
      'next_state': target.dataset.nextState,
      'state_value': target.dataset.stateValue
    }
    state[stateKey] = stateData;
    const pageReviews = document.querySelector('page-reviews');
    if(stateKey == 'landing-block') {
      pageReviews.querySelectorAll('[data-star-value]').forEach(input => input.value = stateData.state_value);
    }
    pageReviews.updateState(stateKey, state);
  }
}

customElements.define('page-reviews', PageReviews);
customElements.define('review-block', ReviewBlock);
